import api from ".";
import cookiesModifier from "../utils/cookies";

import { IUser, IUserInfo } from "../types/user";
import { IImmigrant } from "../types/information";
import { IQuestionnaire } from "../types/questionnaire";

export const getAllUsers = async () => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`users`);
        return res.data as IUser[];
    } catch (error) {
        throw error;
    }
}

export const getSingleUser = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`users/${id}`);
        return res.data as IUserInfo;
    } catch (error) {
        throw error;
    }
}

export const getUserInformation = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`immigrants/applicant/${id}`);
        return res.data as IImmigrant;
    } catch (error) {
        throw error;
    }
}

export const getUserQuestionnaire = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`answers/applicant/${id}`);
        return res.data as IQuestionnaire[];
    } catch (error) {
        throw error;
    }
}